module.exports = __webpack_public_path__ + "static/media/bars.8f7c7972.svg";